import { Button, Card, Flex, Form, Input, Typography } from 'antd';
import { useAuth } from '../components/auth/AuthContext.tsx';
import { useState } from 'react';
import { signUp, LogInProps, login } from '../lib/firebase.ts';
import { Link } from 'react-router-dom';
import { updateProfile } from '../lib/api-client.ts';

export const SignupPage = () => {
  const { error } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleSignIn = async (
    data: LogInProps & { passwordConfirmation: string; name: string },
  ) => {
    setIsLoading(true);
    try {
      await signUp(data);
      await updateProfile({ name: data.name, university: '' });
      await login(data);
      window.location.reload();
    } catch (e) {
      console.error(e);
    }
    setIsLoading(false);
  };

  return (
    <Flex vertical align="center" gap="md">
      <Typography.Title>Crown Sitter</Typography.Title>
      <Typography.Text>シッター用アプリ</Typography.Text>
      <Card style={{ marginTop: 10 }}>
        <Form
          name="login-form"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          onFinish={handleSignIn}
          onFinishFailed={console.error}
          autoComplete={'off'}
          disabled={isLoading}
        >
          <Form.Item<string>
            label="シッター名"
            name="name"
            rules={[{ required: true, message: 'シッター名を入力してください' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item<string>
            label="メールアドレス"
            name="email"
            rules={[{ required: true, message: 'メールアドレスを入力してください' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item<string>
            label="パスワード"
            name="password"
            rules={[{ required: true, message: 'パスワードを入力してください' }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item<string>
            label="パスワード(再入力)"
            name="passwordConfirmation"
            rules={[
              { required: true, message: 'パスワードを入力してください' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('パスワードが一致しません'));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            wrapperCol={{
              offset: 0,
              span: 24,
              sm: { offset: 8, span: 16 },
            }}
          >
            <Button type="primary" htmlType="submit" loading={isLoading}>
              新規登録
            </Button>
          </Form.Item>

          {error && <div style={{ color: 'red' }}>{error}</div>}
        </Form>

        <Link to={'/auth/sign-in'}>ログインはこちら</Link>
      </Card>
    </Flex>
  );
};
